import { Injectable } from '@angular/core';
import { RouterToStoreLinkService } from '@classifieds-sell/shared';
import { AnalyticsService } from './analytics-service';

@Injectable()
export class InitService {
    constructor(private _routerToStoreLinkService: RouterToStoreLinkService,
        private _analyticsService: AnalyticsService
    ) {}

    init() {
        this._routerToStoreLinkService.init();
        this._analyticsService.init();
    }
}
